module.exports = __webpack_public_path__ + "img/leftthigh-endo-mesomorph-male.725fc24e.svg";